import React from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
const ContentEditor: React.FC<React.PropsWithChildren & { className?: string }> = (props) => {
  const { children, className } = props;

  return (
    <Stack className={cn('h-full', className)} direction="col">
      {children}
    </Stack>
  );
};

export default ContentEditor;
